var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c("FormExpansion", {
        attrs: { value: _vm.guest ? null : 0, readonly: !_vm.guest },
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [_vm._v(" Your information ")]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-4 pa-4" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-between gap-4",
                        class: { "flex-col ": _vm.$vuetify.breakpoint.xs },
                      },
                      [
                        _c("SoliText", {
                          attrs: {
                            icon: "person",
                            label: "Your First Name",
                            rules: [
                              (v) => !!v || "Your first name is required",
                            ],
                            hideDetails: "auto",
                            error: _vm.errors.first_name,
                          },
                          model: {
                            value: _vm.form.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "first_name", $$v)
                            },
                            expression: "form.first_name",
                          },
                        }),
                        _vm._v(" "),
                        _c("SoliText", {
                          attrs: {
                            icon: "people",
                            label: "Your Last Name",
                            rules: [(v) => !!v || "Your last name is required"],
                            hideDetails: "auto",
                            error: _vm.errors.last_name,
                          },
                          model: {
                            value: _vm.form.last_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "last_name", $$v)
                            },
                            expression: "form.last_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BookingEmail", {
                      attrs: { hideDetails: "auto", error: _vm.form.email },
                      model: {
                        value: _vm.form.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email",
                      },
                    }),
                    _vm._v(" "),
                    _c("SoliPhone", {
                      attrs: { hideDetails: "auto", error: _vm.form.phone },
                      model: {
                        value: _vm.form.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "phone", $$v)
                        },
                        expression: "form.phone",
                      },
                    }),
                    _vm._v(" "),
                    !_vm.guest
                      ? _c(
                          "div",
                          [
                            _c("v-divider", { staticClass: "mt-4" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex justify-center",
                                staticStyle: { transform: "translateY(-13px)" },
                              },
                              [
                                _c("v-sheet", { staticClass: "w-10 white" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-bold soli-grey flex justify-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                or\n                            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  text: "",
                                  color: "primary",
                                  rounded: "",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.$inertia.visit(_vm.route("login"), {
                                      data: {
                                        successRoute: _vm.$page.url,
                                      },
                                    })
                                  },
                                },
                              },
                              [_vm._v("I already have an account")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      false
        ? _c("FormItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "question",
                  fn: function () {
                    return [_vm._v("Child Information")]
                  },
                  proxy: true,
                },
                {
                  key: "action",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        { staticClass: "gap-2", attrs: { "no-gutters": "" } },
                        [
                          _vm.form.children.length < 3
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "soli-round",
                                      attrs: {
                                        "x-small": "",
                                        outlined: "",
                                        color: "accent",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.form.children.push({
                                            first_name: null,
                                            last_name: _vm.form.last_name,
                                            birthday: null,
                                          })
                                        },
                                      },
                                    },
                                    [_vm._v("Add Another Child")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.children.length > 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "soli-round",
                                      attrs: {
                                        "x-small": "",
                                        outlined: "",
                                        color: "error",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.form.children.splice(-1)
                                        },
                                      },
                                    },
                                    [_vm._v("Remove Last Child")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "response",
                  fn: function () {
                    return _vm._l(
                      _vm.form.children.length,
                      function (child, idx) {
                        return _c(
                          "div",
                          {
                            key: child[idx],
                            staticClass: "flex flex-col gap-4",
                            class: {
                              "mb-4": idx + 1 !== _vm.form.children.length,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex justify-between gap-4",
                                class: {
                                  "flex-col ": _vm.$vuetify.breakpoint.xs,
                                },
                              },
                              [
                                _c("SoliText", {
                                  attrs: {
                                    icon: "person",
                                    label: "Child's First Name",
                                    rules: [
                                      (v) =>
                                        !!v ||
                                        `Your child's first name is required`,
                                    ],
                                    hideDetails: "auto",
                                    error: _vm.errors.child_first_name,
                                  },
                                  model: {
                                    value: _vm.form.child_first_name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "child_first_name",
                                        $$v
                                      )
                                    },
                                    expression: "form.child_first_name",
                                  },
                                }),
                                _vm._v(" "),
                                _c("SoliText", {
                                  attrs: {
                                    icon: "people",
                                    label: "Child's Last Name",
                                    rules: [
                                      (v) =>
                                        !!v ||
                                        `Your child's last name is required`,
                                    ],
                                    hideDetails: "auto",
                                    error: _vm.errors.child_last_name,
                                  },
                                  model: {
                                    value: _vm.form.child_last_name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "child_last_name", $$v)
                                    },
                                    expression: "form.child_last_name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("SoliBirthday", {
                              attrs: {
                                label: "Child's Birthday",
                                required: "",
                                hideDetails: "auto",
                              },
                              model: {
                                value: _vm.form.child_birthday,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "child_birthday", $$v)
                                },
                                expression: "form.child_birthday",
                              },
                            }),
                            _vm._v(" "),
                            idx + 1 !== _vm.form.children.length
                              ? _c("v-divider")
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    )
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2221037695
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.guest
        ? _c("FormSubmit", {
            attrs: {
              dark: "",
              type: "submit",
              loading: _vm.loading,
              valid: "",
              errors: _vm.errors,
              gradient: "gradient-orange",
              icon: "send",
              text: "Continue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }